import { Layout } from 'antd';
import mainBackground from '@Images/gradient-background.jpg';

import { Chatbot } from '@Components/index';
import HeaderApplicationMobile from '@Components/HeaderApplication/mobile/HeaderApplicationMobile';
import PageLayoutResolver from '../components/PageLayoutResolver';

import styles from './wrapper-mobile-page.module.css';

const WrapperMobilePage: React.FC = () => {
  return (
    <Layout
      className={styles.layoutPage}
      style={{ backgroundImage: `url(${mainBackground})` }}
    >
      <Layout>
        <PageLayoutResolver>
          <HeaderApplicationMobile />
        </PageLayoutResolver>
      </Layout>
      <Chatbot />
    </Layout>
  );
};

export default WrapperMobilePage;
